import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "12",
      fill: "#667085"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M8.87 11.25h9.128v1.5H8.869l4.023 4.023-1.06 1.06L5.998 12l5.834-5.834 1.06 1.06z"
    }, null, -1)
  ]))]))
}
export default { render: render }